import { Layout } from 'react-admin';
import { SIDEBAR_WIDTH_PX } from './constants';
import { MyMenu } from './Menu';
import { TopBar } from './TopBar';

// Wrap Layout to expose a shared CSS variable for the sidebar width.
export const CustomLayout = (props: any) => (
  <div style={{ ['--sidebar-width' as string]: `${SIDEBAR_WIDTH_PX}px` }}>
    <Layout {...props} appBar={TopBar} menu={MyMenu} />
  </div>
);
